import { createRouter, createWebHistory } from 'vue-router';

import { analyticsGuard } from '@/router/analytics-guard.ts';
import { mainGuard } from '@/router/main-guard.ts';
import { notFoundGuard } from '@/router/not-found-guard.ts';
import { routes } from '@/router/routes.ts';

declare module 'vue-router' {
  interface RouteMeta {
    layout?: 'default' | 'empty';
  }
}

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 };
  },
  routes,
});

router.beforeEach(analyticsGuard);
router.beforeEach(mainGuard);
router.beforeEach(notFoundGuard);
